import { NavLink, useLocation } from 'react-router-dom';
import { Box, Flex, HStack, Text, Tooltip, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { useKeycloak } from '@react-keycloak/web';
import { isAdmin } from 'utils/auth-utils';

export function SidebarLinks(props: {
    routes: RoutesType[];
    onClose: () => void;
    isCollapsed?: boolean;
}) {
    //   Chakra color mode
    let location = useLocation();
    let activeColor = useColorModeValue('gray.700', 'white');
    let inactiveColor = useColorModeValue('secondaryGray.600', 'secondaryGray.600');
    let activeIcon = useColorModeValue('gray.700', 'white');
    let textColor = useColorModeValue('secondaryGray.500', 'white');
    let brandColor = useColorModeValue('gray.600', 'brand.400');

    const { keycloak } = useKeycloak();
    const adminUser = isAdmin(keycloak!);
    const { routes, onClose, isCollapsed } = props;

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName: string) => {
        return location.pathname.includes(routeName);
    };

    const isMobile = useBreakpointValue({ base: true, lg: false });

    const handleClick = () => {
        if (isMobile && onClose) {
            onClose();
        }
    };

    // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
    const createLinks = (
        routes: RoutesType[],
    ) => {
        return routes.map(
            (
                route: RoutesType,
                index: number
            // eslint-disable-next-line array-callback-return
            ) => {
                // Filtra le rotte che richiedono admin se l'utente non è admin
                if (route.requireAdmin && !adminUser) {
                    return null;
                }

                // Nascondi le rotte dipendente per gli admin
                if (route.layout === '/dipendente' && adminUser) {
                    return null;
                }

                if (route.layout === '/admin' || route.layout === '/auth' || route.layout === '/dipendente') {
                    const linkBody = route.icon ? (
                        <Box>
                            <HStack
                                spacing={isCollapsed ? '0px' : activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
                                py='5px'
                                ps={isCollapsed ? '0px' : '10px'}>
                                <Flex w='100%' alignItems='center' justifyContent='center'>
                                    <Box
                                        color={activeRoute(route.path.toLowerCase()) ? activeIcon : textColor}
                                        me={isCollapsed ? '0px' : '18px'}>
                                        {route.icon}
                                    </Box>
                                    {!isCollapsed && (
                                        <Text
                                            me='auto'
                                            color={activeRoute(route.path.toLowerCase()) ? activeColor : textColor}
                                            fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}>
                                            {route.name}
                                        </Text>
                                    )}
                                </Flex>
                                {!isCollapsed && (
                                    <Box
                                        h='36px'
                                        w='4px'
                                        bg={activeRoute(route.path.toLowerCase()) ? brandColor : 'transparent'}
                                        borderRadius='5px'
                                    />
                                )}
                            </HStack>
                        </Box>
                    ) : (
                        <Box>
                            <HStack
                                spacing={activeRoute(route.path.toLowerCase()) ? '22px' : '26px'}
                                py='5px'
                                ps='10px'>
                                {!isCollapsed && (
                                    <Text
                                        me='auto'
                                        color={activeRoute(route.path.toLowerCase()) ? activeColor : inactiveColor}
                                        fontWeight={activeRoute(route.path.toLowerCase()) ? 'bold' : 'normal'}>
                                        {route.name}
                                    </Text>
                                )}
                                <Box h='36px' w='4px' bg='brand.400' borderRadius='5px' />
                            </HStack>
                        </Box>
                    );

                    return (
                        <NavLink key={index} to={route.layout + route.path} onClick={handleClick}>
                            {isCollapsed ? (
                                <Tooltip label={route.name} placement='right' hasArrow>
                                    {linkBody}
                                </Tooltip>
                            ) : (
                                linkBody
                            )}
                        </NavLink>
                    );
                }
            }
        );
    };
    //  BRAND
    return <>{createLinks(routes)}</>
}

export default SidebarLinks;